import { PRODUCT_TABLE_TYPES } from '../../../lib/constants';

const tableComponent = PRODUCT_TABLE_TYPES.STANDARD;

const columns = (id) => [
  {
    name: 'Lender',
    elements: [
      {
        type: 'ApplyNow',
        props: {
          logoLink: true,
          impressionId: `logo-${id}`,
        },
      },
      {
        type: 'StarRating',
      },
      {
        type: 'ApplyNow',
        props: {
          hideIcon: true,
          impressionId: `cta-${id}`,
        },
      },
    ],
  },
  {
    name: 'APR range',
    width: 200,
    elements: [
      {
        type: 'EditableQuickFacts',
        props: {
          quickFactName: 'getQuickFactFixedAPR',
        },
      },
      {
        type: 'Label',
        props: {
          text: 'Fixed',
        },
      },
      {
        type: 'EditableQuickFacts',
        props: {
          quickFactName: 'getQuickFactVariableAPR',
        },
      },
      {
        type: 'Label',
        props: {
          text: 'Variable',
        },
      },
    ],
  },
  {
    name: 'Min credit score',
    elements: [
      {
        type: 'EditableQuickFacts',
        props: {
          quickFactName: 'getQuickFactMinCreditScore',
        },
      },
    ],
  },
  {
    name: 'Details',
    elements: [
      {
        type: 'ProsAndCons',
      },
    ],
  },
];

export default {
  columns,
  tableComponent,
};
